<nb-card class="mb-0 substitution-mapping-dialog">
  <nb-card-header>{{
    (isEditMode ? 'INVOICE_IMPORTS.SUB.EDIT_DIALOG_TITLE' : 'INVOICE_IMPORTS.SUB.SAVE_DIALOG_TITLE') | translate
  }}</nb-card-header>
  <nb-card-body>
    <form [formGroup]="form">
      <div class="mb-3">
        <div class="small text-muted">{{ 'INVOICE_IMPORTS.SUB.SAVE_FROM' | translate }}</div>
        <div class="fw-semibold">{{ fromCodeDisplay() }} · {{ fromNameDisplay() }}</div>
        <div class="small" *ngIf="entry || existingSubstitution?.statusText">{{ statusDisplay() }}</div>
      </div>
      <div class="mb-3">
        <label class="form-label">{{ 'INVOICE_IMPORTS.SUB.SAVE_TO_NUMBER' | translate }}</label>
        <input class="form-control" formControlName="toSupplierItemNumber" />
      </div>
      <div class="mb-3">
        <label class="form-label">{{ 'INVOICE_IMPORTS.SUB.SAVE_TO_NAME' | translate }}</label>
        <input class="form-control" formControlName="toName" />
      </div>
      <div class="mb-3">
        <div class="form-label">{{ 'INVOICE_IMPORTS.SUB.SAVE_STRATEGY' | translate }}</div>
        <div class="form-check" *ngFor="let s of strategies">
          <input class="form-check-input" type="radio" formControlName="strategy" [value]="s" [id]="'subStrat' + s" />
          <label class="form-check-label" [for]="'subStrat' + s">{{ strategyLabel(s) }}</label>
        </div>
      </div>
      <div class="alert alert-warning small" *ngIf="requiresConfirmation">
        {{ confirmWarningKey() | translate }}
      </div>
      <div class="form-check mb-0" *ngIf="requiresConfirmation">
        <input class="form-check-input" type="checkbox" formControlName="confirmed" id="subConfirmed" />
        <label class="form-check-label" for="subConfirmed">{{ 'INVOICE_IMPORTS.SUB.SAVE_CONFIRM_CHECK' | translate }}</label>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer class="d-flex justify-content-end gap-2">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
      {{ 'INVOICE_IMPORTS.COMMON.CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="submit()" [disabled]="form.invalid">
      {{ (isEditMode ? 'INVOICE_IMPORTS.SUB.EDIT_MAPPING' : 'INVOICE_IMPORTS.SUB.SAVE_MAPPING') | translate }}
    </button>
  </nb-card-footer>
</nb-card>
